var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoDark = function SvgLogoDark(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 14,
    fill: "none",
    viewBox: "0 0 27 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_5846_30702)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_5846_30702)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_5846_30702)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_5846_30702)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear_5846_30702)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear_5846_30702)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_linear_5846_30702)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint7_linear_5846_30702)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint8_linear_5846_30702)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint9_linear_5846_30702)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint10_linear_5846_30702)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint11_radial_5846_30702)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint12_radial_5846_30702)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint13_radial_5846_30702)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint14_radial_5846_30702)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint15_linear_5846_30702)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint16_radial_5846_30702)",
    fillRule: "evenodd",
    d: "m12.774 12.485 7.238-7.26a.21.21 0 0 1 .329.042l3.881 6.575a1.034 1.034 0 0 0 1.905-.72l-1.42-7.406a2.518 2.518 0 0 0-3.977-1.543.235.235 0 0 1-.327-.044A4.65 4.65 0 0 0 17.877.417C16.33.002 14.515.486 13.371 1.63L6.133 8.89a.21.21 0 0 1-.328-.042L1.923 2.274a1.034 1.034 0 0 0-1.904.72l1.42 7.406a2.518 2.518 0 0 0 3.976 1.543.235.235 0 0 1 .328.044 4.65 4.65 0 0 0 2.525 1.712c1.723.462 3.277.017 4.506-1.214m-5.839-2.029a.21.21 0 0 0-.032.254l.005.009a2.977 2.977 0 0 0 4.672.589l7.629-7.649a.21.21 0 0 0 .032-.254l-.005-.008a2.977 2.977 0 0 0-4.672-.589zm16.623-3.833c.044.23-.266.348-.385.146l-1.666-2.82a.21.21 0 0 1 .032-.254l.1-.1a.842.842 0 0 1 1.422.436zm-20.972.87c-.044-.231.267-.349.386-.146l1.665 2.82a.21.21 0 0 1-.032.254l-.099.1a.842.842 0 0 1-1.423-.437z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5846_30702",
    x1: 21.842,
    x2: 25.485,
    y1: 4.533,
    y2: 2.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5846_30702",
    x1: 20.561,
    x2: 15.184,
    y1: 5.639,
    y2: 9.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5846_30702",
    x1: 10.753,
    x2: 7.959,
    y1: 12.196,
    y2: 9.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5846_30702",
    x1: 4.375,
    x2: 6.757,
    y1: 6.045,
    y2: 8.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5846_30702",
    x1: 4.375,
    x2: -2.171,
    y1: 6.045,
    y2: 0.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5846_30702",
    x1: 2.707,
    x2: -0.308,
    y1: 6.996,
    y2: 8.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5846_30702",
    x1: 9.016,
    x2: 6.002,
    y1: 8.525,
    y2: 5.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#1E130E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419,
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5846_30702",
    x1: 20.853,
    x2: 19.354,
    y1: 2.688,
    y2: 3.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#1E130E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.054,
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5846_30702",
    x1: 21.781,
    x2: 20.327,
    y1: 4.4,
    y2: 5.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#1E130E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5846_30702",
    x1: 27.802,
    x2: 20.345,
    y1: 14.971,
    y2: 5.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5846_30702",
    x1: 27.802,
    x2: 20.275,
    y1: 14.971,
    y2: 4.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5846_30702",
    x1: 17.372,
    x2: 9.295,
    y1: 6.786,
    y2: 12.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.067,
    stopColor: "#1E130E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_5846_30702",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.35487 -5.47267 5.47262 .35487 16.932 1.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_5846_30702",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-130.321 10.006 -2.98)scale(2.6969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_5846_30702",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-130.527 10.308 -2.825)scale(3.30275)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.086,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_5846_30702",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-41.92 10.67 -18.475)scale(2.59964)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#1E130E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_5846_30702",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.33236 3.23533 -9.1224 9.39615 11.117 12.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    stopColor: "#1E130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#1E130E",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoDark);
export default ForwardRef;